import { useParams } from 'react-router-dom';
import dots from '../../assets/BugBountyImages/dots.png';
import React, { useEffect, useState } from 'react'
import axios from 'axios';
import ENDPOINT from '../../data/ENDPOINT'

function BugBountyStatus() {

  const { organization_id } = useParams(); // Get org ID from URL
  const [bounties, setBounties] = useState([]);
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(true);

useEffect(() => {
  if (!organization_id) return; // Don't fetch if no org ID

  console.log("Fetching from:", `${ENDPOINT}select-bounties-by-organization.php?organization_id=${organization_id}`);

  axios.get(`${ENDPOINT}select-bounties-by-organization.php?organization_id=${organization_id}`)
    .then((response) => {
      console.log("Full API Response:", response.data);
      setBounties(response.data.bounties || []);
      setStatus(response.data.status);
    })
    .catch((error) => {
      console.error("Error fetching data:", error);
      setStatus("error");
    })
    .finally(() => setLoading(false));
}, [organization_id]);


  return (
    <div className="App">
      <div className='container '>
        <div className='row'>
          <div className='col-lg-12 col-sm-12'>

            <div className='col-12 d-none d-sm-block text-white bg-secondary'>
             <div className='d-flex'>
             <div className='p-2 col-2'><h6>Bounty name</h6></div>
              <div className='p-2 col-2 text-center'><h6>STATUS</h6></div>
              <div className='p-2 col-2 text-center'><h6>Total views</h6></div>
              <div className='p-2 col-2 text-center'><h6>Action</h6></div>
              <div className='p-2 col-2 text-center'><h6>Start Date</h6></div>
              <div className='p-2 col-2 text-center'><h6>Died Line</h6></div>
             </div>
            </div>

           

            {loading ? (
        <p>Loading data...</p>
      ) : status === "success" && bounties.length > 0 ? (
        <ul>
          {bounties.map((bounty) => (
            <li key={bounty.bounty_id}>
                          <div className='d-flex flex-wrap align-items-center justify-content-between border-bottom py-2 '>

<div className='p-2 col-lg-2 col-sm-4'>
  <p className='m-0 '>{bounty.bounty_title}</p>             
</div>
<div className='p-2 col-lg-2 col-sm-4 text-center'>
  <button className='px-2  border border-0 rounded rounded-5'>
    <a className='text-black text-decoration-none' href='#'>{bounty.status}</a>
  </button>
</div>
<div className='p-2 col-lg-2 text-center col-sm-4'>
  <p className='m-0'>4508</p>
</div>
<div className='p-2 col-lg-2 col-sm-6 d-flex justify-content-center align-items-center'>
  <button className='bg-secondary  border border-0 px-3 py-1 '>
    <a className='text-white text-decoration-none' href='#'>View application (209)</a>
  </button>
</div>
<div className='p-2 col-lg-2 text-center col-sm-4'>
  <p className='m-0'>{bounty.start_date}</p>
</div>
<div className='p-2 col-lg-2 text-center col-sm-4'>
  <p className='m-0'>{bounty.deadline}</p>
</div>
<div className='p-2 col-2 text-center'>

</div>
<div className='p-2 col-2 text-end'>
  <button className='border border-0 bg-white'>
    <img src={dots} height='20px' alt="Menu"/>
  </button>
</div>
</div>
            </li>
          ))}
        </ul>
      ) : (
        <p>No bounties found for this organization or an error occurred.</p>
      )}








          </div>
        </div>
      </div>
    </div>
  );
}

export default BugBountyStatus;
